import * as d3 from 'd3'
export default {
  methods: {

    draw_SystemList() {
      // Initial Keyplan, Title, Summary
      if (!this.pdfDrawing) {
        this.current.sys = null
        this.current.mouseover = null
        d3.select(`#TITLE`).text('3D System Boundary')
        d3.select(`#KEY_PLAN`).attr('xlink:href', this.Boundary + `keyplan/KP_0000.svg`)
      }
      this.init_Summary()

      this.canvasSystems = this.canvasForm
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      let x_ = this.system.x
      let y_ = this.system.y
      let pageNo = ((this.current.page-1) * 30)
      this.setData.slice(pageNo, pageNo+30).forEach((d,i)=> {

        let listGroup = this.canvasSystems
        .append('g')
        .attr('id', `SYSTEM_${d.SYS}`)
        .attr('transform', `translate(${x_}, ${y_})`)
        
        // LIST TITLE
        let title = listGroup
        .append('g')
        .attr('id', `SYS_GROUP_${d.SYS}`)
        .attr('transform', `translate(0, 0)`).attr('cursor', 'pointer')
        .on('mouseover', ()=> {
          this.current.mouseover = d.SYS

          d3.select(`#SYS_NO_${d.SYS}`).attr('fill', '#44A9DF')
          d3.select(`#SYS_DESC_${d.SYS}`).attr('fill', '#44A9DF')
          d3.select(`#BOX_${d.SYS}`).transition().duration(50).attr('stroke', '#44A9DF')
          d3.select(`#IMG_${d.SYS}`).transition().duration(50).attr('opacity', .5)
          d3.select(`#KEY_PLAN`)
          .attr('xlink:href', this.Boundary + `keyplan/KP_${d.SYS}.svg`)
          .on('error', ()=> {
            d3.select(`#KEY_PLAN`).attr('xlink:href', this.Boundary + `keyplan/KP_0000.svg`)
          })
          this.draw_SummaryReflash(d)
        })
        .on('mouseout', ()=> {
          d3.select(`#SYS_NO_${d.SYS}`).attr('fill', '#000')
          d3.select(`#SYS_DESC_${d.SYS}`).attr('fill', '#333')
          d3.select(`#BOX_${d.SYS}`).transition().duration(300)
          .attr('stroke', ()=> {
            let color = '#bcbcbc'
            if(d.MCC_TOT>0 && d.MCC_REM==0) color = this.system.mcc
            if(d.PCC_A) color = this.system.pcc
            return color
          })
          d3.select(`#IMG_${d.SYS}`).transition().duration(300).attr('opacity', 1)
        })
        .on('click', ()=> {
          this.current.sys = d.SYS
          this.draw_Boundary(d)
        })

        title
        .append('text')
        .attr('id', `SYS_NO_${d.SYS}`)
        .attr('transform', `translate(0, 3)`).attr('font-size', 13).attr('fill', '#000')
        .text(d.SYS)

        title
        .append('image')
        .attr('xlink:href', this.HOST + `icon/Modal.svg`).attr('x', this.getNode(`#SYS_NO_${d.SYS}`)+3).attr('y', -7).attr('width', 10)

        title
        .append('text')
        .attr('id', `SYS_DESC_${d.SYS}`)
        .attr('transform', `translate(0, 15)`)
        .attr('font-size', 10).attr('fill', '#333')
        .text(()=> {
          if(d.DESC.length>30) return d.DESC.substr(0,28) + '...'
          else return d.DESC
        })
  
        title
        .append('rect')
        .attr('id', `BOX_${d.SYS}`)
        .attr('x', 0).attr('y', 20).attr('rx',5).attr('ry',5)
        .attr('width', 174).attr('height', 135)
        .attr('fill', '#fff')
        .attr('fill-opacity', 0.7)
        .attr('stroke', ()=> {
          let color = '#bcbcbc'
          if(d.MCC_TOT>0 && d.MCC_REM==0) color = this.system.mcc
          if(d.PCC_A) color = this.system.pcc
          return color
        })
        .attr('stroke-width', (d.MCC_TOT>0 && d.MCC_REM==0) || d.PCC_A ? 1.5 : .5)

        if(this.current.list=='JPG') {
          title
          .append('image')
          .attr('id', `IMG_${d.SYS}`)
          .attr('xlink:href', this.Boundary + `img/${d.SYS}.jpg`).attr('x', 2).attr('y', 22).attr('width', 170) .attr('opacity', 1)
          .on('error', ()=> {
            d3.select(`#IMG_${d.SYS}`).attr('xlink:href', this.Boundary + `img/NA.jpg`)
          })
        } else this.draw_Items(title, d)

        x_ += 205
        if(x_>1400) {
          x_ = 370
          y_ += 190
        }
      })

      this.pagination()
    },


    draw_Items(selection, data) {

      let item = selection
      .append('g')
      .attr('transform', `translate(10, 40)`)

      item
      .append('text')
      .attr('transform', `translate(85, 0)`).attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'end')
      .text('Total')

      item
      .append('text')
      .attr('transform', `translate(120, 0)`).attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'end')
      .text('Actual')

      item
      .append('text')
      .attr('transform', `translate(155, 0)`).attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'end')
      .text('Remain')

      item
      .append('line')
      .attr('x1', 0).attr('y1', 7.5)
      .attr('x2', 160).attr('y2', 7.5)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      let y_ = 20
      this.items.forEach(d=> {

        item
        .append('rect')
        .attr('x', 0).attr('y', y_-10).attr('rx', 2).attr('ry', 2)
        .attr('width', 45).attr('height', 13.5).attr('opacity', .5)
        .attr('fill', ()=> {
          let color = '#fff'
          if(data[`${d.code}_TOT`] > data[`${d.code}_ACT`] && data[`${d.code}_ACT`] > 0) color = '#FEED57'
          if(data[`${d.code}_TOT`] > 0 && data[`${d.code}_REM`] == 0 ) color = '#CDDC37'
          
          return color
        })

        item
        .append('text')
        .attr('transform', `translate(23, ${y_})`)
        .attr('font-size', 9.5).attr('fill', data[`${d.code}_TOT`] ==0 ? '#E0E0DF' : '#333').attr('text-anchor', 'middle')
        .text(d.name)

        item
        .append('text')
        .attr('transform', `translate(85, ${y_})`)
        .attr('font-size', 9.5).attr('fill',  data[`${d.code}_TOT`] ==0 ? '#E0E0DF' : '#333').attr('text-anchor', 'end')
        .text(data[`${d.code}_TOT`])
        .call(this.event_Link, data, d.code+'_TOT')

        item
        .append('text')
        .attr('transform', `translate(120, ${y_})`)
        .attr('font-size', 9.5).attr('fill', data[`${d.code}_ACT`] ==0 ? '#E0E0DF' : '#333').attr('text-anchor', 'end')
        .text(data[`${d.code}_ACT`])
        .call(this.event_Link, data, d.code+'_ACT')


        item
        .append('text')
        .attr('transform', `translate(155, ${y_})`)
        .attr('font-size', 9.5).attr('fill',  data[`${d.code}_REM`] ==0 ? '#E0E0DF' : '#333').attr('text-anchor', 'end')
        .text(data[`${d.code}_REM`])
        .call(this.event_Link, data, d.code+'_REM')

        y_ += 15
      })
      
    }

  }
}